/**
 * Contains all the methods needed for uibModalServices.
 * Should migrate all uib modal services when components migrated to angular
 */
export class UibModalService {
    /*@ngInject*/
    constructor($uibModal) {
        this.$uibModal = $uibModal;
    }
    // From company service
    // Add in company service when changed uibModal to NgbModal
    showAllCompanies() {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowTopClass: 'four-dot-five-modal-extra-small',
            component: 'companies',
            resolve: {}
        });
    }
}
//# sourceMappingURL=uibModalService.js.map